import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemBdName, FormItemBdNo} from '../BD/FormChooseBd.jsx'
import {FormItemRuleTitle} from '../BDRULE/FormChooseBdrule.jsx'

export default function FormChooseBdrule(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemBdNo />
            <FormItemBdName />
            <FormItemRuleTitle label="实体标题" />
        </FormChooseDesign>
    )
}
